import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6376efac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }

interface props {
  showForm: any;
  placement: any;
  title: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Drawer',
  props: {
    showForm: { default: false },
    placement: { default: "right" },
    title: { default: "" }
  },
  emits: ["closePopup", "submitPopup"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const propsData = __props;

const afterOpenChange = (_bool: boolean) => {
  emits("closePopup", false);
};

return (_ctx: any,_cache: any) => {
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    open: _ctx.showForm,
    class: "draw-kima-home",
    "root-class-name": "kima-drawer-root",
    title: _ctx.title,
    placement: _ctx.placement,
    onClose: afterOpenChange
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ]),
    _: 3
  }, 8, ["open", "title", "placement"]))
}
}

})